import { ChangeDetectorRef, Component, effect, inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataBindingDirective, KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';
import { SortDescriptor } from '@progress/kendo-data-query';
import { SubSink } from 'subsink';
import { AuthApiService } from '../apiCalls/auth-api.service';
import { AuthService } from '../auth/auth.service';
import { RoutesConst } from '../shared/route-const';

export interface UserListImpersonationData {
  id: number;
  UserName: string;
  CompanyId: number;
  CompanyName: string;
  FirstName: string;
  LastName: string;
  SerialNumbers: string[];
}

@Component({
  selector: 'app-impersonation',
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule, KENDO_GRID, KENDO_INPUTS, MatTooltipModule],
  templateUrl: './impersonation.component.html',
  styleUrl: './impersonation.component.scss',
})
export class ImpersonationComponent {
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;

  private subs = new SubSink();

  routesConst = RoutesConst;

  private readonly authApiSvc = inject(AuthApiService);
  private readonly authSvc = inject(AuthService);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly userDataImpersonate = this.authApiSvc.getAllUsersImpersonateAs();

  sort: SortDescriptor[] = [{ field: 'CompanyName', dir: 'asc' }];
  loading = false;
  gridView: UserListImpersonationData[] = [];

  constructor() {
    this.loading = true;

    effect(() => {
      const data = this.userDataImpersonate() as UserListImpersonationData[];
      if (data) {
        this.loading = false;
        this.gridView = data as UserListImpersonationData[];
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  // Handle search input
  onFilter(value: string): void {
    const terms = value?.trim().toLowerCase().split(/\s+/) ?? [];
    let users = this.userDataImpersonate() ?? [];

    if (terms.length > 0 && value) {
      users = users.filter((user) =>
        terms.every(
          (term) =>
            user.SerialNumbers?.some((sn) => sn.toLowerCase().includes(term)) ||
            user.CompanyName?.toLowerCase().includes(term) ||
            user.FirstName?.toLowerCase().includes(term) ||
            user.LastName?.toLowerCase().includes(term) ||
            user.UserName?.toLowerCase().includes(term),
        ),
      );
    }

    this.gridView = users;
    this.dataBinding.skip = 0;
    this.cdRef.detectChanges();
  }

  impersonationUser(username: string): void {
    this.authSvc.impersonateAsFn(username);
  }
}
